var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0134 0.743164H6.6891C5.81341 0.743164 5.10352 1.34657 5.10352 2.09091V12.199C5.10352 12.9434 5.81341 13.5468 6.6891 13.5468H15.0134C15.8891 13.5468 16.599 12.9434 16.599 12.199V2.09091C16.599 1.34657 15.8891 0.743164 15.0134 0.743164Z",
    stroke: "#5C73FF",
    strokeWidth: 1.48649
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6531 4.1123H2.32875C1.45306 4.1123 0.743164 4.71571 0.743164 5.46005V15.5682C0.743164 16.3125 1.45306 16.9159 2.32875 16.9159H10.6531C11.5288 16.9159 12.2387 16.3125 12.2387 15.5682V5.46005C12.2387 4.71571 11.5288 4.1123 10.6531 4.1123Z",
    stroke: "#5C73FF",
    strokeWidth: 1.48649
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e5da789812b936facc99683a22610982.svg";
export { ForwardRef as ReactComponent };